import { createSlice } from '@reduxjs/toolkit';
import { ShiftImpact } from 'api/AICoachShiftImpactApi';
import { closeAIChat } from 'handlers/aiChat';
import { getShiftImpact } from 'thunks';

export interface ShiftImpactState {
  data: ShiftImpact | null;
  isLoading: boolean;
  isError: boolean;
}

const initialState: ShiftImpactState = {
  data: null,
  isLoading: false,
  isError: false,
};

const shiftImpact = createSlice({
  name: 'shiftImpact',
  initialState,
  reducers: {
    clearShiftImpact: (state) => {
      state.data = null;
      state.isLoading = false;
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getShiftImpact.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.data = null;
    });
    builder.addCase(getShiftImpact.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
    });
    builder.addCase(getShiftImpact.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(closeAIChat, (state) => {
      state.data = null;
      state.isLoading = false;
      state.isError = false;
    });
  },
});

export const { clearShiftImpact } = shiftImpact.actions;

export default shiftImpact.reducer;
